import React from "react";
import GlobalStyle from './GlobalStyle';
import MainPage from './pages/mainpage/MainPage';

function App() {
  return (
    <div className="App">
      <GlobalStyle /> 
      <MainPage />

    </div>
  );
}

export default App;
